import { render, staticRenderFns } from "./SeasonReview.vue?vue&type=template&id=763e033a&"
import script from "./SeasonReview.vue?vue&type=script&lang=js&"
export * from "./SeasonReview.vue?vue&type=script&lang=js&"
import style0 from "./SeasonReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports